import {createFsCockpitAuthedAxiosInstance} from "./axiosFsCockpitAuthAdapter";
import type {
    GetScanJobResultResponse,
    GetScanJobsResponse,
    UUID4
} from "./wineScannerTypes";

export * from "./wineScannerTypes";

const WINE_SCANNER_BASE_URL = process.env.REACT_APP_WINE_SCANNER_BASE_URL;

const wineScannerClient = createFsCockpitAuthedAxiosInstance({
    baseURL: WINE_SCANNER_BASE_URL
});

export interface GetScanJobsRequest {
    customer_id: string;
}

export async function getScanJobs(request: GetScanJobsRequest): Promise<GetScanJobsResponse> {
    const response = await wineScannerClient.request({
        method: 'GET',
        url: '/scans',
        params: {customer_id: request.customer_id},
        responseType: 'json'
    });
    return response.data as GetScanJobsResponse;
}

export async function getScanJobResult(jobId: UUID4): Promise<GetScanJobResultResponse> {
    const response = await wineScannerClient.request({
        method: 'GET',
        url: `/scans/${jobId}/result`,
        responseType: 'json'
    });
    return response.data as GetScanJobResultResponse;
}

export const wineScannerApi = {
    getScanJobs,
    getScanJobResult
};
